fourToldApp.controller("passwordRecoveryCntrl", function ($scope, services, $location, $window, $mdDialog, theme, $sce) {
    $scope.forgotPassword = new Object();
    $scope.theme = theme.getTheme();
    $scope.resultError = false;
    $scope.match = function () {
        $scope.isMatch = angular.equals($scope.forgotPassword.newPassword, $scope.forgotPassword.confirmPassword);
        console.log($scope.isMatch);
    };
    $scope.unlock = window.localStorage.getItem("UNLOCK");
    $scope.changePassword = function (ev) {
        if ($scope.register.currentPassword && $scope.register.password && $scope.confirm && $scope.isMatch) $scope.passwordChange($scope.register.currentPassword, $scope.register.password);
    };
    if ($scope.theme && $scope.theme.passwords) $scope.hints = $scope.theme.passwords.hints.replace(/(?:\r\n|\r|\n)/g, "<br>");
    $scope.passwordVisibility = false;
    $scope.passwordConfirmVisibility = false;
    $scope.recoverPassword = function () {
        $scope.resultError = false;
        $scope.forgotPassword.username = window.sessionStorage.getItem("phoneNumber");

        if ($scope.forgotPassword.username) {
            if ($scope.unlock) {
                $scope.progressEdit = "ok";
                services.unlock_user.unlock(
                    {},
                    { userName: $scope.forgotPassword.username, token: $scope.forgotPassword.token },
                    function (response) {
                        $scope.progressEdit = undefined;
                        if (response.code == 1) {
                            $scope.showAlert("Usuario desbloqueado exitosamente");
                        }

                        if (response.code == -206) {
                            $scope.resultError = true;
                            $scope.error = "El código ingresado es inválido.";
                        }
                    },
                    function err() {
                        $scope.progressEdit = undefined;
                        $scope.dialog("Número telefónico incorrecto o Error en el formato telefónico.", "error-toast");
                        $scope.loginError = true;
                    }
                );
            } else {
                $scope.progressEdit = "ok";
                services.recover_password_token.password(
                    {},
                    $scope.forgotPassword,
                    function (response) {
                        $scope.progressEdit = undefined;
                        if (response.code == 1) {
                            $scope.showAlert("Contraseña cambiada exitosamente");
                        }

                        if (response.code == -206) {
                            $scope.resultError = true;
                            $scope.error = "El código ingresado es inválido.";
                        }

                        if (response.code == -111) {
                            $scope.resultError = true;
                            $scope.error = "La contraseña no cumple con las políticas de seguridad necesarias.";
                        }

                        if (response.code == -5) {
                            $scope.resultError = true;
                            var erorMessage = response.data.errorMessage.replaceAll("\n", "<br/>");
                            $scope.error = "La contraseña no cumple con las políticas de seguridad necesarias.\n" + response.data.errorMessage;
                        }
                    },
                    function err() {
                        $scope.progressEdit = undefined;
                        $scope.dialog("Número telefónico incorrecto o Error en el formato telefónico.", "error-toast");
                        $scope.loginError = true;
                    }
                );
            }
        }
    };
    $scope.cancel = function () {
        $location.path("/");
    };
    $scope.showAlert = function (message) {
        var confirm = $mdDialog.confirm().title("").textContent(message).ok("OK");

        $mdDialog.show(confirm).then(function (answer) {
            window.sessionStorage.removeItem("phoneNumber");
            window.localStorage.removeItem("UNLOCK");
            $location.path("/");
        });
    };

    $scope.login = function () {
        $location.path("/");
    };

    $scope.visibilityPassword = function (id) {
        var x = document.getElementById(id);
        if (x.type === "password") {
            x.type = "text";
            $scope.passwordVisibility = true;
        } else {
            x.type = "password";
            $scope.passwordVisibility = false;
        }
    };

    $scope.visibilityPasswordConfirm = function (id) {
        var x = document.getElementById(id);
        if (x.type === "password") {
            x.type = "text";
            $scope.passwordConfirmVisibility = true;
        } else {
            x.type = "password";
            $scope.passwordConfirmVisibility = false;
        }
    };

    $scope.$on("$locationChangeStart", function (event, next, current) {
        if ($window.sessionStorage.getItem("requiredPasswordChange") === "true") {
            event.preventDefault();
        }
    });
    $scope.renderHtml = function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
});
